import lpApp from '../lp_app';
import ConditionsEvo from '../../logic/condition_evo';

/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/options.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpOptionsIndex {
  constructor() {
    this.options = {};
  }

  updateOption(opt, i = 0) {
    if (opt) {
      let changeStatus = false;
      if (this.options[opt.id] && this.options[opt.id].value !== opt.value) changeStatus = true;
      else if (!this.options[opt.id]) changeStatus = true;

      this.options[opt.id] = { value: opt.value, index: i };

      if (changeStatus === true) ConditionsEvo.execOptionHook(opt.id);
    }
  }

  loadFromO() {
    if (lpApp.getState().loadedOvc && Object.keys(lpApp.getState().loadedOvc).length > 0) {
      const os = lpApp.getState().loadedOvc.oF;
      const cs = lpApp.getState().loadedOvc.cF;
      // Object.keys(os).map(idx => this.options[idx] = {value: os[idx]}, this);
      // Object.keys(cs).map(idx => this.options[idx] = {value: cs[idx]}, this);
      if (os && Object.keys(os).length > 0)
        Object.keys(os).map(idx => this.updateOption({ id: idx, value: os[idx] }), this);

      if (cs && Object.keys(cs).length > 0)
        Object.keys(cs).map(idx => this.updateOption({ id: idx, value: cs[idx] }), this);
    }
  }

  delOption(id) {
    if (Object.prototype.hasOwnProperty.call(this.options, id)) {
      delete this.options[id];
      ConditionsEvo.execOptionHook(id);
    }
  }

  getOption(id) {
    if (this.options[id]) return this.options[id];
    // let loaded_option = getOptionPass(id);
    // if(loaded_option)
    //     return {value: loaded_option};
    return { value: false };
    // return this.options[id] ? this.options[id] : getOptionPass(id);
  }

  isLoaded() {
    return (Object.keys(this.options).length > 0);
  }
}


export default LpOptionsIndex;



// WEBPACK FOOTER //
// ./src/app/indexes/options.js